import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';

/** Fetches the caller's actual profile type from the backend. */
const fetchProfileType = (http: HttpClient) =>
  http.get(`${environment.apiUrl}/users/role`, { responseType: 'text' as const });

const isCorporate = (type: string | null | undefined): boolean => {
  const t = (type || '').toUpperCase();
  return t === 'CORPORATE' || t === 'CORPORATES';
};

/**
 * Only CORPORATE profiles may enter /app/employer.
 * Everyone else is redirected to their own dashboard.
 */
export const corporateOnlyGuard: CanActivateFn = () => {
  const http = inject(HttpClient);
  const router = inject(Router);

  return fetchProfileType(http).pipe(
    map((type) => {
      if (isCorporate(type)) return true;
      const t = (type || '').toUpperCase();
      return router.createUrlTree(
        t === 'PANELIST' || t === 'PANEL' ? ['/app/panelist'] : ['/app/candidate'],
      );
    }),
    catchError(() => of(router.createUrlTree(['/auth/login']))),
  );
};

/**
 * CORPORATE profiles may NOT enter candidate/panelist areas, they are redirected to the corporate dashboard.
 */
export const nonCorporateGuard: CanActivateFn = () => {
  const http = inject(HttpClient);
  const router = inject(Router);

  return fetchProfileType(http).pipe(
    map((type) => (isCorporate(type) ? router.createUrlTree(['/app/employer']) : true)),
    // If the role can't be determined (e.g. profile not created yet),
    // don't block, other flows (complete-profile) handle that case.
    catchError(() => of(true)),
  );
};
